(ns teamoesterreich.firebase.fb-questionnaire-helper
  (:require
    [teamoesterreich.store :as store]))



(defn calculate-personal-questionnaires-question-sum [questionnaireId]
  (reduce (fn [c [qk q]]
            (let [ap (reduce (fn [c2 [ak a]]
                               ;(log/out "answer " (:points a) (clj->js a))
                               (+ c2 (:points a)))
                             0
                             (:answers q))]
              ;(log/out "question " (:question q) ": " ap)
              (+ c ap)))
          0
          (get-in (deref store/app-state) [:user-questionnaires questionnaireId :questions]))
  )

(defn calculate-location-questionnaires-question-sum [locationId questionnaireId]
  (reduce (fn [c [qk q]]
            (let [ap (reduce (fn [c2 [ak a]]
                               ;(log/out "answer " (:points a) (clj->js a))
                               (+ c2 (:points a)))
                             0
                             (:answers q))]
              ;(log/out "question " (:question q) ": " ap)
              (+ c ap)))
          0
          (get-in (deref store/app-state) [:locations locationId :questionnaires questionnaireId :questions])))


(defn get-personal-questionnaires []
  (filter #(not (nil? %))
          (mapv (fn [[k q]]
                  (when (and (:appearance-self q) (:active q)) (assoc q :questionnaireId k)))
                (get-in (deref store/app-state) [:questionnaires]))))

(defn get-location-questionnaires []
  (filter #(not (nil? %))
          (mapv (fn [[k q]]
                  (when (and (:appearance-location q) (:active q)) (assoc q :questionnaireId k)))
                (get-in (deref store/app-state) [:questionnaires]))))

(defn get-location-questionnaires-max []
  (reduce (fn [c q] (+ c (or ((keyword "#points") q) 0))) 0 (get-location-questionnaires)))


(defn get-location-questionnaire-max [questionnaireId]
  (get-in (deref store/app-state) [:questionnaires questionnaireId :#points]))

(defn get-personal-questionnaires-max []
  (reduce (fn [c q] (+ c (or ((keyword "#points") q) 0))) 0 (get-personal-questionnaires)))

(defn get-location-questionnaires-sum [locationId]
  (reduce (fn [c qid]
            (let [sum (calculate-location-questionnaires-question-sum locationId qid)]
              ;(log/out "locationq " locationId qid "->" sum)
              (+ c (or (int sum) 0))
              )) 0 (mapv :questionnaireId (get-location-questionnaires))))

(defn get-personal-questionnaires-sum []
  (reduce (fn [c qid]
            (let [sum (calculate-personal-questionnaires-question-sum qid)]
              ;(log/out "persq " qid "->" sum)
              (+ c (or (int sum) 0))
              )) 0 (mapv :questionnaireId (get-personal-questionnaires))))






(defn get-location-questionnaire-stars [locationId questionnaireId]
  ;(log/debug "get-location-questionnaire-stars" locationId questionnaireId  (calculate-location-questionnaires-question-sum locationId questionnaireId) "/" (get-location-questionnaire-max questionnaireId))
  (/ (.min js/Math 10 (.round js/Math (* 5 (/ (calculate-location-questionnaires-question-sum locationId questionnaireId) (get-location-questionnaire-max questionnaireId))))) 2)
  )


(defn get-personal-questionnaire-stars [questionnaireId]
  (/ (.min js/Math 10 (.round js/Math (* 5 (/ (calculate-personal-questionnaires-question-sum questionnaireId) (get-personal-questionnaires-max))))) 2)
  )


(defn get-location-stars [locationId]
  ;(log/debug "get-location-stars" (get-location-questionnaires-sum locationId) "/" (get-location-questionnaires-max))
  (/ (.min js/Math 10 (.round js/Math (* 5 (/ (get-location-questionnaires-sum locationId) (get-location-questionnaires-max))))) 2)
  )

(defn get-personal-stars []
  ;(log/debug "get-personal-stars" (get-personal-questionnaires-sum) "/" (get-personal-questionnaires-max))
  (/ (.min js/Math 10 (.round js/Math (* 10 (/ (get-personal-questionnaires-sum) (get-personal-questionnaires-max))))) 2)
  )